import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import { getHomePage, getConsolePage } from '~/utils/assist'

Vue.use(Vuex)

const state = {
  redirectPath: getHomePage(),
  // 学识云首页地址
  xueshicloudHomePath: getHomePage(),
  // 学识云控制台
  xueshicloudConsolePath: getConsolePage()
}

const options = {
  state,
  mutations,
  actions,
  modules: {
  }
}

export default new Vuex.Store(options)



// WEBPACK FOOTER //
// ./src/store/index.js